import React from 'react';
import styled from 'styled-components';
import { Translate } from 'react-localize-redux';
import moment from 'moment';

interface InfoLabelProps {
  labelName: string;
}

export const InfoLabel: React.FC<InfoLabelProps> = (props) => {
  const { labelName } = props;
  const currentDate = moment(Date.now()).add(14, 'days').format('DD MMM YYYY');
  return (
    <StyledInfo>
      <StyledImageNLabelContainer>
        <StyledLabel>
          <Translate id="LABEL.INFO.LABEL.TITLE" />
        </StyledLabel>
        <StyledLabel>
          <Translate id="USER_PROFILE.LABEL.DELETE.LABEL" />
          <UnOrderedList>
            <UnOrderedListItem>
              <Translate
                id="LABEL.INFO.LABEL.LIST.ITEM.ONE"
                data={{ LABELNAME: labelName }}
              />
            </UnOrderedListItem>
            <UnOrderedListItem>
              <Translate
                id="LABEL.INFO.LABEL.LIST.ITEM.TWO"
                data={{ LABELNAME: labelName }}
              />
            </UnOrderedListItem>
            <UnOrderedListItem>
              <Translate
                id="LABEL.INFO.LABEL.LIST.ITEM.THREE"
                data={{ LABELNAME: labelName }}
              />
            </UnOrderedListItem>
          </UnOrderedList>
        </StyledLabel>
        <StyledLabel>
          <Translate id="LABEL.INFO.LABEL.FOOTER" /> {currentDate}
        </StyledLabel>
      </StyledImageNLabelContainer>
    </StyledInfo>
  );
};

const StyledInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background: #f3d993;
  border-color: #f3d993;
  border-radius: 4px;
  margin-bottom: 10px;
  margin-top: 30px;
  margin-bottom: 30px;
`;

const UnOrderedList = styled.ul`
  display: block;
`;

const UnOrderedListItem = styled.li``;

const StyledLabel = styled.label`
  font-size: 14px;
  line-height: 17px;
  color: ${({ theme }) => theme.colors.primary};
`;

const StyledImageNLabelContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
